"use strict";
/**
 * In-memory ring buffer of recent "the request never reached the server"
 * failures, for field diagnosis.
 *
 * The operator works from a phone, where devtools are not available. Without
 * somewhere to look afterwards, a failure seen in the stands has to be
 * reconstructed from memory hours later. This keeps the last few so they can
 * be read — and copied — on the device.
 *
 * A leaf module with no imports: network-error.ts writes to it and
 * services/connection-check.ts reads from it, and neither can create a cycle
 * through here.
 *
 * Memory only, capped, never persisted — consistent with the rest of the
 * client's storage rules. Entries carry no credentials: the path is recorded,
 * never headers or bodies.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.recordNetworkFailure = recordNetworkFailure;
exports.getRecentNetworkFailures = getRecentNetworkFailures;
exports.clearNetworkFailures = clearNetworkFailures;
/** Keep this small: it is a diagnostic aid, not a log. */
const MAX_ENTRIES = 10;
const entries = [];
/** Record a failure, evicting the oldest once the buffer is full. */
function recordNetworkFailure(entry) {
    entries.push(entry);
    if (entries.length > MAX_ENTRIES) {
        entries.shift();
    }
}
/** Most recent failures, newest first. */
function getRecentNetworkFailures() {
    return [...entries].reverse();
}
/** Drop everything. Exposed for tests and for the UI's clear action. */
function clearNetworkFailures() {
    entries.length = 0;
}
